import { Checkbox, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import React, { useMemo, useRef, useState } from 'react';
import ArticlesRow from './ArticlesRow';
import { useVirtualizer } from '@tanstack/react-virtual';

const ROW_HEIGHT = 70;

const ArticlesTablePreview = ({ newArticles, editedArticles, withOutChangesArticles, withIssuesArticles }) => {
  const parentRef = useRef(null);

  const [articleExcelTypeFilter, setArticleExcelTypeFilter] = useState(['created', 'edited', 'with-issues']);
  const filteredArticles = useMemo(() => {
    let filteredArticles = [];

    if (articleExcelTypeFilter.length > 0) {
      if (articleExcelTypeFilter.includes('with-issues')) {
        filteredArticles = [...filteredArticles, ...withIssuesArticles];
      }
      if (articleExcelTypeFilter.includes('created')) {
        filteredArticles = [...filteredArticles, ...newArticles];
      }
      if (articleExcelTypeFilter.includes('edited')) {
        filteredArticles = [...filteredArticles, ...editedArticles];
      }
      if (articleExcelTypeFilter.includes('with-out-changes')) {
        filteredArticles = [...filteredArticles, ...withOutChangesArticles];
      }
    }

    return filteredArticles;
  }, [newArticles, editedArticles, withOutChangesArticles, withIssuesArticles, articleExcelTypeFilter]);

  const articlesMapping = useMemo(() => {
    const mapping = {};
    newArticles.forEach((format) => {
      mapping[format.code] = 'created';
    });
    editedArticles.forEach((format) => {
      mapping[format.code] = 'edited';
    });
    withOutChangesArticles.forEach((format) => {
      mapping[format.code] = 'with-out-changes';
    });
    withIssuesArticles.forEach((format) => {
      mapping[format.code] = 'with-issues';
    });
    return mapping;
  }, [newArticles, editedArticles, withOutChangesArticles, withIssuesArticles]);

  const rowVirtualizer = useVirtualizer({
    count: filteredArticles.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => ROW_HEIGHT,
    overscan: 5,
  });
  return (
    <>
      <div className="articles-table-filter-container">
        <div
          style={{
            width: '20rem',
          }}
        >
          <InputLabel size="small" id="centerType-label">
            Tipo articulo
          </InputLabel>
          <br />
          <Select
            style={{
              width: '20rem',
            }}
            size="small"
            id="demo-multiple-checkbox"
            labelId="centerType-label"
            multiple
            value={articleExcelTypeFilter}
            onChange={(e) => setArticleExcelTypeFilter(e.target.value)}
            input={<OutlinedInput label="centerType-label" />}
            renderValue={(selected) => {
              const statusMapping = {
                created: 'Por Crear',
                edited: 'Por editar',
                'with-out-changes': 'Sin cambios',
                'with-issues': 'Con problemas',
              };
              return selected.map((s) => statusMapping[s]).join(', ');
            }}
          >
            <MenuItem value="created">
              <Checkbox checked={articleExcelTypeFilter.includes('created')} />
              <ListItemText primary="Por Crear" />
            </MenuItem>
            <MenuItem value="edited">
              <Checkbox checked={articleExcelTypeFilter.includes('edited')} />
              <ListItemText primary="Por editar" />
            </MenuItem>
            <MenuItem value="with-out-changes">
              <Checkbox checked={articleExcelTypeFilter.includes('with-out-changes')} />
              <ListItemText primary="Sin cambios" />
            </MenuItem>
            <MenuItem value="with-issues">
              <Checkbox checked={articleExcelTypeFilter.includes('with-issues')} />
              <ListItemText primary="Con problemas" />
            </MenuItem>
          </Select>
        </div>
      </div>
      <div className="articles-table-major-container">
        <div className="articles-table-inner">
          <table className="table-preview table-articles-preview table-header">
            <thead>
              {filteredArticles.length > 0 && (
                <tr>
                  <th>CODIGO ARTICULO</th>
                  <th>IMAGEN PEQUEÑA</th>
                  <th>ARTES FINALES</th>
                  <th>NOMBRE</th>
                  <th>CLUSTERS</th>
                  <th>REGIONALIDAD</th>
                  <th>MONTAJE</th>
                  {/* <th>IMPRIMIBLE</th> */}
                  <th>ACTIVO</th>
                  <th>CANTIDAD</th>
                  <th>PALABRAS CLAVES</th>
                  {/* <th>PDF CASTELLANO</th>
                  <th>PDF PAIS VASCO</th>
                  <th>PDF CATALUÑA</th>
                  <th>PDF GALICIA</th> */}
                </tr>
              )}
            </thead>
          </table>

          <div ref={parentRef} className="table-content-articles-container">
            <table className="table-preview table-articles-preview table-body">
              {filteredArticles.length > 0 ? (
                <tbody
                  style={{
                    height: `${rowVirtualizer.getTotalSize()}px`,
                    position: 'relative',
                    display: 'block',
                  }}
                >
                  {rowVirtualizer.getVirtualItems().map((virtualRow) => {
                    const row = filteredArticles[virtualRow.index];
                    if (!row) return null;

                    row.type = articlesMapping[row.code];

                    return (
                      <ArticlesRow
                        key={`${row?.code}-${virtualRow.index}`}
                        article={row}
                        index={virtualRow.index}
                        height={`${virtualRow.size - 20}px`}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: `${virtualRow.size}px`,
                          transform: `translateY(${virtualRow.start}px)`,
                        }}
                      />
                    );
                  })}
                </tbody>
              ) : (
                <tbody style={{ height: `10rem` }}>
                  <tr style={{ height: `10rem` }}>
                    <span
                      style={{
                        color: '#6e6b6b',
                        fontSize: '1.2rem',
                        fontStyle: 'italic',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '1rem 2rem',
                      }}
                    >
                      No hay artículos para mostrar
                    </span>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArticlesTablePreview;
